const spdata2022 = [
    {
    "Roll": "18BEC087",
    "Name": "Rishika Manoj Patwa",
    "Company": "E-Infochips",
    "Personal": "rishikapatwa21@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/rishika-patwa-1251b61b4"
    },
    {
    "Roll": "17BEC033",
    "Name": "Harsh Prajapati",
    "Company": "Soleos Solar",
    "Personal": "harshprajapati4@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/harsh1345/"
    },
    {
    "Roll": "17BEC128",
    "Name": "Yash Jha",
    "Company": "Jekson Vision",
    "Personal": "yash.jha0501@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/yash-jha-a9544b211"
    },
    {
    "Roll": "17BEC154",
    "Name": "Lipi Karkar",
    "Company": "Nit Rourkela",
    "Personal": "lipikarkar8@gmail.com",
    "Linkedin": "https://drive.google.com/file/d/1qxDvls-DVxnLOH30XBL8yS3s4z0x7P18/view?usp=sharing"
    },
    {
    "Roll": "18BEC002",
    "Name": "Aashvi Ketak Gajjar",
    "Company": "Soleos Solar",
    "Personal": "aashvi3110@gmail.com",
    "Linkedin": 'https://www.linkedin.com/in/aashvig/'
    },
    {
    "Roll": "18BEC003",
    "Name": "Abha Mihir Buch",
    "Company": "Larsen And Toubro Limited",
    "Personal": "abhabuch@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/abhabuch/"
    },
    {
    "Roll": "18BEC004",
    "Name": "Aftaab Alam M Siddiqui",
    "Company": "Kodiodo Technologies Private Limited",
    "Personal": "aftaabsiddiqui00@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/aftaabasiddiqui/"
    },
    {
    "Roll": "18BEC005",
    "Name": "Akanksha Arora",
    "Company": "Pratham Software",
    "Personal": "akankshaarora129@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/akanksha-arora-3556a9211/"
    },
    {
    "Roll": "18BEC006",
    "Name": "Ambika Lakhera",
    "Company": "Openfive",
    "Personal": "18bec006@nirmauni.ac.in",
    "Linkedin": "https://www.linkedin.com/in/ambika-lakhera-a16b5a1a6/"
    },
    {
    "Roll": "18BEC007",
    "Name": "Amita Trilokinath Mohta ",
    "Company": "E-Infochips",
    "Personal": "amita.mohta@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/amita-mohta-815455178/"
    },
    {
    "Roll": "18BEC008",
    "Name": "Aravind Kannan",
    "Company": "Csir-Central Electronics Engineering Research Institute (Csir-Ceeri)",
    "Personal": "aravindkannan213@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/aravind-kannan-162123173/"
    },
    {
    "Roll": "18BEC009",
    "Name": "Ashu Mittal",
    "Company": "E-Infochips",
    "Personal": "ashumittal847@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ashu-mittal-034225208"
    },
    {
    "Roll": "18BEC010",
    "Name": "Atish Kumar Jain",
    "Company": "Monster.Com India Private Limited",
    "Personal": "atishj18700@gmail.com",
    "Linkedin": "www.linkedin.com/in/atish-jain-41a562183"
    },
    {
    "Roll": "18BEC013",
    "Name": "Batavia Vardhan Vijay",
    "Company": "E-Infochips",
    "Personal": "bataviavardhan@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vardhan-batavia-4849051a5/"
    },
    {
    "Roll": "18BEC014",
    "Name": "Deep Naresh Bhavsar",
    "Company": "Optimized Solutions Limited",
    "Personal": "rs74295@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/deep-bhavsar-4830721a8/"
    },
    {
    "Roll": "18BEC015",
    "Name": "Vishwam Ketan Bhavsar",
    "Company": "E-Infochips",
    "Personal": "vishwambhavsar@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vishwam-"
    },
    {
    "Roll": "18BEC016",
    "Name": "Hemant Rajkumar Bhojwani",
    "Company": "E-Infochips",
    "Personal": "hemantbhojwani11@gmail.com",
    "Linkedin": "www.linkedin.com/in/hemant-bhojwani"
    },
    {
    "Roll": "18BEC017",
    "Name": "Jigar Boda Dineshbhai",
    "Company": "Robocon",
    "Personal": "jigarpatel71756@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/jigar-boda-5bb3691b0/"
    },
    {
    "Roll": "18BEC019",
    "Name": "Chinmaya Mishra",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "18bec019@nirmauni.ac.in",
    "Linkedin": "https://www.linkedin.com/in/chinmaya-mishra-b28366200"
    },
    {
    "Roll": "18BEC020",
    "Name": "Krutarth Parag Choksi",
    "Company": "Nit Rourkela",
    "Personal": "krutarthchoksi0801@gmail.com",
    "Linkedin": "www.linkedin.com/in/krutarth-choksi-030419179"
    },
    {
    "Roll": "18BEC021",
    "Name": "Monish Siraj Chunara",
    "Company": "E-Infochips",
    "Personal": "monishchunara002@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/monish-chunara-30360a19b/"
    },
    {
    "Roll": "18BEC022",
    "Name": "Rutvik Rakeshkumar Dalal",
    "Company": "E-Infochips",
    "Personal": "rutvikdalal.rd@gmail.com",
    "Linkedin": "https://www.linkedin.com/feed/?trk=homepage-basic_google-one-tap-submit"
    },
    {
    "Roll": "18BEC023",
    "Name": "Damini Rajendra Rathi",
    "Company": "Reliance Jio Infocomm Limited",
    "Personal": "18bec023@nirmauni.ac.in",
    "Linkedin": "linkedin.com/in/damini-rathi-ab01a31b3"
    },
    {
    "Roll": "18BEC024",
    "Name": "Kanan Prashantkumar Dave",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "kanandave11@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/kanan-dave-0b740a183/"
    },
    {
    "Roll": "18BEC025",
    "Name": "Devesh L Asawa",
    "Company": "Thruster",
    "Personal": "deveshasawa999@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/devesh-asawa-2992a8180/"
    },
    {
    "Roll": "18BEC027",
    "Name": "Divyansh Rai",
    "Company": "Verma Gmbh",
    "Personal": "divyansh.rai00@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/divyansh-rai-ab953713a/"
    },
    {
    "Roll": "18BEC028",
    "Name": "Maitry Dumaswala",
    "Company": "Jekson Vision",
    "Personal": "18bec028@nirmauni.ac.in",
    "Linkedin": "https://www.linkedin.com/in/maitry-dumaswala?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BxqzJSF5ySm%2B8kXS67aqxYw%3D%3D"
    },
    {
    "Roll": "18BEC029",
    "Name": "Eshan Saraogi",
    "Company": "Harman Connected Services Corporation India Pvt. Ltd",
    "Personal": "eshansaraogi@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/eshan-saraogi-23b2b1182/"
    },
    {
    "Roll": "18BEC030",
    "Name": "Giriraj Singh Chouhan",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "girirajsinghchouhan800@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/giriraj-singh-chouhan-6b2640180?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BcRL9QAj0TkSMmVvHZklo%2Bg%3D%3D"
    },
    {
    "Roll": "18BEC031",
    "Name": "Khushi Xitij Gorasia",
    "Company": "E-Infochips",
    "Personal": "khushigorasia06@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/khushi-gorasia/"
    },
    {
    "Roll": "18BEC032",
    "Name": "Kavan Apurva Gujarathi",
    "Company": "Cse Solution Pvt Ltd",
    "Personal": "kavan.gujarathi@gmail.com ",
    "Linkedin": "https://www.linkedin.com/in/kavan-gujarathi-52738a171/"
    },
    {
    "Roll": "18BEC033",
    "Name": "Gazal Gupta ",
    "Company": "Inficube Technolab",
    "Personal": "gazalgupta1120@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/gazal-gupta-5a0237189"
    },
    {
    "Roll": "18BEC034",
    "Name": "Harshil Chetankumar Patel",
    "Company": "E-Infochips",
    "Personal": "harshilpatel621@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/harshil-patel-07/"
    },
    {
    "Roll": "18BEC036",
    "Name": "Harshvadan Mihir",
    "Company": "E-Infochips",
    "Personal": "hmihir4@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/harshvadan-mihir-056b971b0/"
    },
    {
    "Roll": "18BEC037",
    "Name": "Hasit Pankaj Trivedi",
    "Company": "Openfive",
    "Personal": "hasittrivedi10@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/hasit-trivedi/"
    },
    {
    "Roll": "18BEC038",
    "Name": "Helly Mehul Champaneri",
    "Company": "Securemax Sevices And Solutions",
    "Personal": "hellychampaneri@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/helly-champaneri/"
    },
    {
    "Roll": "18BEC039",
    "Name": "Miral Herma",
    "Company": "Sphere Rays Technolabs Pvt. Ltd.",
    "Personal": "miral21herma@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/miral-herma-5a0541172/"
    },
    {
    "Roll": "18BEC040",
    "Name": "Ishan Gupta",
    "Company": "E-Infochips",
    "Personal": "ishangupta1601@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ishan-gupta-ab41b21a0/"
    },
    {
    "Roll": "18BEC041",
    "Name": "Soham Rajeshkumar Jani",
    "Company": "E-Infochips",
    "Personal": "soham.jani@outlook.com",
    "Linkedin": "https://www.linkedin.com/in/soham-jani-3244891b2"
    },
    {
    "Roll": "18BEC042",
    "Name": "Jeenang Lalitkumar Shah",
    "Company": "E-Infochips",
    "Personal": "jeenangshah1903@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/jeenang-shah/"
    },
    {
    "Roll": "18BEC043",
    "Name": "Pragya Vikramsingh Jhala",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "pragyajhala26@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/pragya-jhala-8a4278181/"
    },
    {
    "Roll": "18BEC044",
    "Name": "Jivansu Nirav Vyas",
    "Company": "Intech",
    "Personal": "jivansu.vyas@gmail.com",
    "Linkedin": "linkedin.com/in/jivansu-vyas-95a279204"
    },
    {
    "Roll": "18BEC045",
    "Name": "Neel Nirajbhai Joshi",
    "Company": "In House | Ece,Itnu",
    "Personal": "neeljoshi3110@gmail.com",
    "Linkedin": "https://in.linkedin.com/in/neel-joshi-52ab60194"
    },
    {
    "Roll": "18BEC046",
    "Name": "Sanika Mandar Joshi",
    "Company": "E-Infochips",
    "Personal": "sanikamjoshi@rediffmail.com",
    "Linkedin": 'https://www.linkedin.com/in/sanika-joshi-3a9727178/'
    },
    {
    "Roll": "18BEC047",
    "Name": "Het Ratilal Kanzariya",
    "Company": "Gujarat Narmada Valley Fertilizers & Chemicals Limited (Gnfc)",
    "Personal": "hetkanzariya17@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/het-kanzariya-b333b01b5"
    },
    {
    "Roll": "18BEC048",
    "Name": "Khyat Kamal Patel",
    "Company": "Jekson Vision",
    "Personal": "khyatpatel417@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/khyat-patel-a07aa41b3/"
    },
    {
    "Roll": "18BEC049",
    "Name": "Janyae Girish Lahori",
    "Company": "Openfive",
    "Personal": "18bec049@nirmauni.ac.in",
    "Linkedin": "https://www.linkedin.com/in/janyae-lahori-42b2361b2/"
    },
    {
    "Roll": "18BEC051",
    "Name": "Harsh Hemal Mandalaywala",
    "Company": "Jekson Vision",
    "Personal": "harsh.mandalay@gmail.com",
    "Linkedin": "www.linkedin.com/in/harsh-mandalaywala"
    },
    {
    "Roll": "18BEC052",
    "Name": "Viraj Prashant Mankad",
    "Company": "E-Infochips",
    "Personal": "mankadviraj@gmail.com",
    "Linkedin": "www.linkedin.com/in/viraj-mankad"
    },
    {
    "Roll": "18BEC053",
    "Name": "Yesha Tushar Masharu",
    "Company": "Openfive",
    "Personal": "yeshamasharu@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/yesha-masharu-7a3a7a192?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bxf56tTXYRkOSgqw3OM78Og%3D%3D"
    },
    {
    "Roll": "18BEC054",
    "Name": "Mayank Ray",
    "Company": "Jekson Vision",
    "Personal": "mayankray224@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/mayank-ray/"
    },
    {
    "Roll": "18BEC056",
    "Name": "Vimoli Harshal Mehta",
    "Company": "E-Infochips",
    "Personal": "vimolimehta@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vimoli-mehta-1b6985206/"
    },
    {
    "Roll": "18BEC057",
    "Name": "Hardik Mistry Sanjaykumar",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "mistryhardik9908@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/mistry-hardik-76367b1b5"
    },
    {
    "Roll": "18BEC058",
    "Name": "Mitali Pitliya",
    "Company": "Consultech",
    "Personal": "18bec058@nirmauni.ac.in",
    "Linkedin": "https://www.linkedin.com/in/mitali-pitliya-0926441b2"
    },
    {
    "Roll": "18BEC059",
    "Name": "Modi Divy Bhavesh",
    "Company": "E-Infochips",
    "Personal": "divymodi1999@gmail.com",
    "Linkedin": "linkedin.com/in/divy-m-5b9038132"
    },
    {
    "Roll": "18BEC060",
    "Name": "Anoopkumar Nair ",
    "Company": "E-Infochips",
    "Personal": "nairanoopkumar24@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/anoopkumar-nair-7b72411b6/"
    },
    {
    "Roll": "18BEC061",
    "Name": "Nairit Joshi",
    "Company": "E-Infochips",
    "Personal": "Ernairitjoshi@gmail.com",
    "Linkedin": "/"
    },
    {
    "Roll": "18BEC062",
    "Name": "Nandan Bhanvadia",
    "Company": "Soleos Solar",
    "Personal": "bhanvadianandan@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/nandan-bhanvadia-6b0772198"
    },
    {
    "Roll": "18BEC063",
    "Name": "Gaurav Hamirbhai Nanera",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "ghnanera184@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/gaurav-nanera-02485320b"
    },
    {
    "Roll": "18BEC064",
    "Name": "Neel Pankaj Jain",
    "Company": "Adaptive Engineering Private Limited",
    "Personal": "neeljain821@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/neel-jain-087ab1171"
    },
    {
    "Roll": "18BEC065",
    "Name": "Nishit Dinesh Chechani",
    "Company": "E-Infochips",
    "Personal": "nishitchechani@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/nishit-chechani-b71132208/"
    },
    {
    "Roll": "18BEC066",
    "Name": "Nitin Pradeep Agarwal",
    "Company": "Thruster",
    "Personal": "agarwalnitin953@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/nitin-agarwal-2a947b201"
    },
    {
    "Roll": "18BEC067",
    "Name": "Parin Alpesh Parikh",
    "Company": "E-Infochips",
    "Personal": "parin.parikh10@gmail.com",
    "Linkedin": "www.linkedin.com/in/parinparikh10"
    },
    {
    "Roll": "18BEC068",
    "Name": "Bhoomi Bharat Parmar",
    "Company": "Soleos Solar",
    "Personal": "parmarbhoomi81@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/bhoomi-parmar-19a51a1a0"
    },
    {
    "Roll": "18BEC069",
    "Name": "Sanjaykumar Parmar",
    "Company": "Openfive",
    "Personal": "sanjayparmar2402@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/sanjay-parmar-a30b82170"
    },
   
    {
    "Roll": "18BEC072",
    "Name": "Daxal Girishbhai Patel",
    "Company": "E-Infochips",
    "Personal": "daxalpatel2372@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/daxal-patel-4bb009181/"
    },
    {
    "Roll": "18BEC075",
    "Name": "Vandit Mayurbhai Prajapati",
    "Company": "Openfive",
    "Personal": "vanditp20@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vandit-m-prajapati/"
    },
    {
    "Roll": "18BEC076",
    "Name": "Vishal A Prajapati",
    "Company": "Prajapati Fibre Glass",
    "Personal": "vishalprajapati9601@gmail.com",
    "Linkedin": "https://www.google.com/url?sa=t&source=web&rct=j&url=https://in.linkedin.com/in/vishal-prajapati-83564b180&ved=2ahUKEwjw3JW9wKrxAhUTumMGHVPoBxEQjjh6BAgEEAE&usg=AOvVaw2DJB4fg83YwonZ-tnF-fnS"
    },
    {
    "Roll": "18BEC078",
    "Name": "Pranit Soni",
    "Company": "Soleos Solar",
    "Personal": "pranitsoni1999@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/pranit-soni-b5b00a181"
    },
    {
    "Roll": "18BEC079",
    "Name": "Prateek Pandya",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "prateek786pandya@gmail.com",
    "Linkedin": "www.linkedin.com/in/prateek-pandya-02b149176"
    },
    {
    "Roll": "18BEC080",
    "Name": "Priyansh Jain",
    "Company": "E-Infochips",
    "Personal": "priyanshjain602@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/priyansh-jain-943005181"
    },
    {
    "Roll": "18BEC081",
    "Name": "Pulkit Suresh Devpura",
    "Company": "Soleos Solar",
    "Personal": "pulkitdevpura2806@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/pulkitdevpura/"
    },
    {
    "Roll": "18BEC082",
    "Name": "Raghav Devendra Lakhotia",
    "Company": "E2Logy Software Solutions Pvt. Ltd.",
    "Personal": "raghavmaheshwari1104@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/raghav-lakhotia-3a03a2211"
    },
    {
    "Roll": "18BEC083",
    "Name": "Divyesh Ranpariya",
    "Company": "Openfive",
    "Personal": "divyeshranpariya23@gmail.com",
    "Linkedin": "linkedin.com/in/divyesh-ranpariya-b367a6173"
    },
    {
    "Roll": "18BEC085",
    "Name": "Revant Nirav Lala",
    "Company": "Genuine Xray And Radiological Equipment Pvt Ltd",
    "Personal": "revantlala@gmail.com",
    "Linkedin": "www.linkedin.com/in/revant-lala"
    },
    {
    "Roll": "18BEC086",
    "Name": "Rhea Sansowa",
    "Company": "Jekson Vision",
    "Personal": "rhea.s.sansowa@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/rhea-sansowa-60177016a/"
    },
    {
    "Roll": "18BEC088",
    "Name": "Rishita Deepak Malhotra",
    "Company": "E2Logy Software Solutions Pvt. Ltd.",
    "Personal": "18rishitamalhotra@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/rishita-malhotra-3a09061a9/"
    },
 
    {
    "Roll": "18BEC090",
    "Name": "Hard Siddharth Rokad",
    "Company": "E-Infochips",
    "Personal": "hard.rokad@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/hard-rokad-60758b1b0/"
    },
    {
    "Roll": "18BEC091",
    "Name": "Taman Sachanandani ",
    "Company": "Dazzle Robotics",
    "Personal": "taman.sachanandani00@gmail.com",
    "Linkedin": "http://linkedin.com/in/taman-sachanandani-915a63209"
    },
    {
    "Roll": "18BEC092",
    "Name": "Sakshi Sumit Agrawal",
    "Company": "Soleos Solar",
    "Personal": "sakshiagrawal0704@gmail.com",
    "Linkedin": "linkedin.com/in/sakshi-agrawal-81467616a/"
    },
   
    {
    "Roll": "18BEC095",
    "Name": "Sanskriti Mishra",
    "Company": "A.Lakshmi Press & Forge Works",
    "Personal": "18bec095@nirmauni.ac.in",
    "Linkedin": "https://www.linkedin.com/in/sanskriti-mishra-7261a3199/"
    },
  
    {
    "Roll": "18BEC097",
    "Name": "Saumya Tejas Shah",
    "Company": "Thruster",
    "Personal": "stshah2000@gmail.com",
    "Linkedin": "www.linkedin.com/in/saumya-shah-85872316b"
    },
    {
    "Roll": "18BEC099",
    "Name": "Purvansh Shah",
    "Company": "Goldman Sachs",
    "Personal": "purvansh11@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/purvansh-shah/"
    },
    {
    "Roll": "18BEC100",
    "Name": "Yashasvi Girishbhai Shah",
    "Company": "E-Infochips",
    "Personal": "shahyashasvi2711@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/yashasvi-shah-2973991a5/"
    },
    {
    "Roll": "18BEC101",
    "Name": "Shivam Kapildev Pandey",
    "Company": "E-Infochips",
    "Personal": "shivam3523pandey@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/shivam-pandey-389952182/"
    },
    {
    "Roll": "18BEC102",
    "Name": "Shivam Shukla",
    "Company": "Redwall Technologies Pvt. Ltd.",
    "Personal": "shivamshukla752@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/shivam-shukla-30ba771b7/"
    },
    {
    "Roll": "18BEC104",
    "Name": "Anuj Shukla",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "sanuj1321@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/anuj-shukla-8b177516a/"
    },
    {
    "Roll": "18BEC105",
    "Name": "Parjanya Rakeshbhai Shukla",
    "Company": "Godrej Industries Limited (Chemicals)",
    "Personal": "parjanyashukla.ps@gmail.com",
    "Linkedin": "www.linkedin.com/in/parjanyashukla"
    },
   
    {
    "Roll": "18BEC107",
    "Name": "Siddhant Gaurav Patel",
    "Company": "Musikaar",
    "Personal": "siddhantgpatel01@gmail.com",
    "Linkedin": "www.linkedin.com/in/siddhant-patel-377a7120b"
    },
   
    {
    "Roll": "18BEC109",
    "Name": "Mihir Kapil Soni",
    "Company": "Redwall Technologies Pvt. Ltd.",
    "Personal": "mihirksoni@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/mihir-soni-b556021a4/"
    },
    {
    "Roll": "18BEC110",
    "Name": "Shubham Vikas Soni",
    "Company": "Redwall Technologies Pvt. Ltd.",
    "Personal": "shubhamsoni611@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/shubhamsoni1/"
    },
 
    {
    "Roll": "18BEC112",
    "Name": "Suyash Anil Malik",
    "Company": "Medusind Solutions",
    "Personal": "suyashmalik63@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/suyash-a-malik-096805165/"
    },
    
    {
    "Roll": "18BEC115",
    "Name": "Riya Dilip Tanna",
    "Company": "E-Infochips",
    "Personal": "tanna.riya03@gmail.com ",
    "Linkedin": "linkedin.com/in/riya-tanna-b14719172"
    },
    {
    "Roll": "18BEC116",
    "Name": "Anisha Thakkar",
    "Company": "Jekson Vision",
    "Personal": "anishathakkar912@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/anisha-thakkar-a08971179/"
    },
    {
    "Roll": "18BEC117",
    "Name": "Kaushik Thumar",
    "Company": "Sd Trading Ltd.",
    "Personal": "thumarkaushik19@gmail.com",
    "Linkedin": "www.linkedin.com/in/thumarkaushik19"
    },
    {
    "Roll": "18BEC118",
    "Name": "Toshita Sharma",
    "Company": "Verma Gmbh",
    "Personal": "toshita2000@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/toshita-sharma-79894a1a4/"
    },
    {
    "Roll": "18BEC119",
    "Name": "Dehit Hitendra Trivedi ",
    "Company": "In House | Ece,Itnu",
    "Personal": "dehit.trivedi@gmail.com",
    "Linkedin": "https://in.linkedin.com/in/dehit-trivedi-62a223195"
    },
    {
    "Roll": "18BEC120",
    "Name": "Vivek Vagheswari",
    "Company": "Ewarn Systems Pvt. Ltd.",
    "Personal": "vivekvagheswari2000@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vivek-vagheswari-649076199"
    },
    {
    "Roll": "18BEC121",
    "Name": "Abhay Vasjariya",
    "Company": "Robocon",
    "Personal": "abhaypatel2672@gmail.com",
    "Linkedin": "http://linkedin.com/in/abhay-patel-7a441a1a0"
    },
    {
    "Roll": "18BEC122",
    "Name": "Vincent Abraham",
    "Company": "Openfive",
    "Personal": "vincent.ahm@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vincent-abraham-0205/"
    },
    {
    "Roll": "18BEC123",
    "Name": "Virag Chirag Shah",
    "Company": "Oizom Instruments Pvt. Ltd.",
    "Personal": "viragcshah@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/viragcshah7585"
    },
    {
    "Roll": "18BEC124",
    "Name": "Vishwa Chintan Shah",
    "Company": "Cse Solution Pvt Ltd",
    "Personal": "vishwashah40@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vishwa-shah-941165132/"
    },
   
    {
    "Roll": "18BEC126",
    "Name": "Yash Talesara",
    "Company": "Openfive",
    "Personal": "yash1999talesara@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/yash-talesara-7901a1179/"
    },
   
    {
    "Roll": "18BEC128",
    "Name": "Yugank Kulshrestha",
    "Company": "Xceltec Interactive Pvt Ltd",
    "Personal": "18bec128@niramuni.ac.in",
    "Linkedin": "https://www.linkedin.com/in/yugank-kulshrestha-670a85185/"
    },
    {
    "Roll": "18BEC129",
    "Name": "Shivam Kamal Agrawal",
    "Company": "Nit Rourkela",
    "Personal": "ska18102000@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/shivam-agrawal-83b3581a6"
    },
    {
    "Roll": "19BEC502",
    "Name": "Mihir Gandhi",
    "Company": "Soleos Solar",
    "Personal": "mihirgandhi.official@gmail.com",
    "Linkedin": "www.linkedin.com/in/mihir-gandhi-a9501653"
    },
   
    {
    "Roll": "19BEC507",
    "Name": "Rama Krishna Krishna Mekala",
    "Company": "Netsol It Solution Pvt. Ltd.",
    "Personal": "ramakrishnamekala129@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ramakrishna-mekala-4a7937a0/"
    },
    {
    "Roll": "19BEC509",
    "Name": "Dhairyarajsinh Jadeja",
    "Company": "Ztek Control Systems Private Limited",
    "Personal": "dhairyarajjadeja@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/dhairyarajsinh-jadeja-5722161ab/"
    },
    {
    "Roll": "19BEC511",
    "Name": "Sanyam Santosh Pathak ",
    "Company": "Godrej & Boyce Mfg. Co. Ltd.",
    "Personal": "sanyampathak17@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/sanyam-pathak-bb247b1b2/"
    },
    {
    "Roll": "19BEC506",
    "Name": "Sufiabanu Farooqui",
    "Company": "Consultech",
    "Personal": "zainzuber7@gmail.com",
    "Linkedin": "/"
    }
    ]

 export default spdata2022;